import { useEffect, useState } from 'react';
import { getDatabase, ref, get } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { loadDoNotShipIndex } from '../services/doNotShipGuard';
import { canPlaceOrderFor } from '../logic/orderPlacementGuard';

const norm10 = (m) => String(m || '').replace(/\D/g, '').slice(-10);

/**
 * Do-Not-Ship gate for TAKING an order (the courier-desk gate is separate).
 *
 * A customer flagged for repeated COD returns costs us both courier legs every
 * time. Blocking only at dispatch is too late — the order has been promised to
 * the customer by then. This blocks at the point of sale, and only a manager
 * and above may override.
 *
 *   const { checkMobile, role, ready } = useOrderPlacementGuard();
 *   const guard = checkMobile(customer.mobile);   // { allowed, blocked, canOverride, reason }
 */
export const useOrderPlacementGuard = () => {
    const [index, setIndex] = useState(() => new Map());
    const [role, setRole] = useState('');
    const [ready, setReady] = useState(false);

    useEffect(() => {
        let alive = true;
        loadDoNotShipIndex()
            .then((m) => { if (alive) setIndex(m); })
            .catch(() => { /* index unavailable — fail OPEN, see below */ })
            .finally(() => { if (alive) setReady(true); });

        const u = getAuth().currentUser;
        if (u) {
            get(ref(getDatabase(), `users/${u.uid}/role`))
                .then((s) => { if (alive) setRole(String(s.val() || '').toLowerCase()); })
                .catch(() => {});
        }
        return () => { alive = false; };
    }, []);

    // Fails OPEN on purpose: if the index could not load we must not block the
    // whole desk from taking orders. The courier-desk gate still catches a
    // flagged customer before anything actually ships.
    const checkMobile = (mobile) => canPlaceOrderFor(index.get(norm10(mobile)) || null, role);

    return { checkMobile, role, ready };
};

export default useOrderPlacementGuard;
